module.exports = __webpack_public_path__ + "static/media/ktp_guide_correct.b350a795.svg";